'use client'

import { useLenis } from 'lenis/react'
import { useRef } from 'react'
import { Image } from '~/components/image'

export function Background() {
  const imageRef = useRef(null)

  useLenis(({ progress }) => {
    if (imageRef.current) {
      imageRef.current.style.transform = `translateY(${progress * 10}%)`
    }
  })

  return (
    <div className="absolute top-0 left-0 right-0 bottom-0 overflow-clip">
      <div
        className="absolute top-0 left-0 max-dt:translate-x-[-10%] dt:right-0 aspect-[1440/12467] max-dt:w-[1440px]"
        ref={imageRef}
      >
        <Image src="/images/background.webp" alt="" fill unoptimized priority />
      </div>
      <div className="absolute top-[75%] left-0 right-0 bottom-0 bg-[linear-gradient(180deg,#ffffff_0%,#000000_100%)] mix-blend-multiply opacity-50" />
    </div>
  )
}
